import LayerMetadataSelect from './LayerMetadataSelect'
import { SelectOption } from './OptionSelect'
import { SubscriptionPlanType } from '../../types/subscription'

// All tiers are selectable for layer curation (unlike tenant plans, which gate Pro).
const TIER_OPTIONS: SelectOption<SubscriptionPlanType>[] = [
  { label: 'Free', value: SubscriptionPlanType.FREE },
  { label: 'Pro', value: SubscriptionPlanType.PRO },
  { label: 'Enterprise', value: SubscriptionPlanType.ENTERPRISE },
]

const toTierPayload = (tier: SubscriptionPlanType) => ({ tier })

interface LayerTierSelectProps {
  fileId: string
  value: SubscriptionPlanType
  className?: string
}

const LayerTierSelect = ({ fileId, value, className }: LayerTierSelectProps) => (
  <LayerMetadataSelect
    fileId={fileId}
    value={value}
    options={TIER_OPTIONS}
    toPayload={toTierPayload}
    placeholder="Select Tier"
    className={className}
  />
)

export default LayerTierSelect
